module.exports = __webpack_public_path__ + "img/akun.37c3c2c.png";